import stringify from 'json-stable-stringify'
import fastDeepEqual from 'fast-deep-equal/es6'

/**
 * Gets a cacheable string for an object.
 * @param obj
 */
export function getCacheKeyForObject(obj: unknown): string {
  return stringify(obj)
}

/**
 * Checks that a value is not nil.
 * @param value
 */
export function isNotNil<T>(
  value: T | null | undefined,
): value is Exclude<T, null | undefined> {
  return value !== undefined && value !== null
}

/**
 * Whether the values are deeply equal.
 *
 * @param left
 * @param right
 */
export function deepEqual<T>(left: T, right: T): boolean {
  return fastDeepEqual(left, right)
}
